module.exports = __webpack_public_path__ + "img/5679ad9.png";